"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ChartContext_1 = require("../../../context/ChartContext");
const useActiveSpectrum_1 = require("../../../hooks/useActiveSpectrum");
const Utilities_1 = require("./Utilities");
function useInView({ correlation }) {
    const { data: spectraData, xDomain, yDomain, displayerMode, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    return (0, react_1.useMemo)(() => (0, Utilities_1.isInView)(spectraData, activeTab, activeSpectrum, xDomain, yDomain, displayerMode, correlation), [
        activeSpectrum,
        activeTab,
        correlation,
        displayerMode,
        spectraData,
        xDomain,
        yDomain,
    ]);
}
exports.default = useInView;
